/**
=========================================================
* ClubOS - v4.0.1
=========================================================

* Product Page: https://www.creative-tim.com/product/soft-ui-dashboard-react
* Copyright 2023 Creative Tim (https://www.creative-tim.com)

Coded by www.creative-tim.com

 =========================================================

* The above copyright notice and this permission notice shall be included in all copies or substantial portions of the Software.
*/

// prop-types is a library for typechecking of props
import PropTypes from "prop-types";

// @mui material components
import Grid from "@mui/material/Grid";

// ClubOS components
import SoftBox from "components/SoftBox";
import SoftTypography from "components/SoftTypography";

// ClubOS examples
import DefaultNavbar from "examples/Navbars/DefaultNavbar";
import PageLayout from "examples/LayoutContainers/PageLayout";

// Authentication layout components
import Footer from "layouts/authentication/components/Footer";

function CoverLayout({ color, header, title, description, image, top, children }) {
  return (
    <PageLayout background="white">
      <DefaultNavbar
        action={{
          type: "external",
          route: "https://athelites.netlify.app/",
          label: "Athelite Home",
          color: "dark",
        }}
      />
      <Grid
        container
        justifyContent="center"
        alignItems={{ xs: "center", md: "flex-start" }}
        sx={{
          minHeight: { xs: "100vh", md: "75vh" },
          margin: 0,
        }}
      >
        <Grid item xs={11} sm={8} md={5} xl={3}>
          <SoftBox mt={{ xs: 0, md: top }} sx={{ pt: { xs: 0, md: "7rem" } }}>
            <SoftBox pt={3} px={3}>
              {!header ? (
                <>
                  <SoftBox mb={1}>
                    <SoftTypography variant="h3" fontWeight="bold" color={color} textGradient>
                      {title}
                    </SoftTypography>
                  </SoftBox>
                  <SoftTypography variant="body2" fontWeight="regular" color="text">
                    {description}
                  </SoftTypography>
                </>
              ) : (
                header
              )}
            </SoftBox>
            <SoftBox p={3}>{children}</SoftBox>
          </SoftBox>
        </Grid>

        <Grid item xs={12} sm={6} md={5}>
          <SoftBox
            height="100%"
            display={{ xs: "none", sm: "block" }}
            position="relative"
            right={{ sm: "-6rem", md: "-10rem", lg: "-12rem", xl: "-16rem" }}
            mr={{ sm: -8, md: -12, lg: -14, xl: -16 }}
            sx={{
              transform: "skewX(-10deg)",
              overflow: "hidden",
              borderBottomLeftRadius: ({ borders: { borderRadius } }) => borderRadius.lg,
              minHeight: { sm: "50vh", md: "75vh" },
            }}
          >
            <SoftBox
              ml={{ sm: -4, md: -6, lg: -8 }}
              height="100%"
              sx={{
                background: `url(${image}) center/cover no-repeat, linear-gradient(135deg, #1a237e 0%, #0d47a1 40%, #01579b 70%, #006064 100%)`,
                transform: "skewX(10deg)",
              }}
            />
          </SoftBox>
        </Grid>
      </Grid>
      <Footer />
    </PageLayout>
  );
}

// Setting default values for the props of CoverLayout
CoverLayout.defaultProps = {
  header: "",
  title: "",
  description: "",
  color: "info",
  top: 20,
};

// Typechecking props for the CoverLayout
CoverLayout.propTypes = {
  color: PropTypes.oneOf([
    "primary",
    "secondary",
    "info",
    "success",
    "warning",
    "error",
    "dark",
    "light",
  ]),
  header: PropTypes.node,
  title: PropTypes.string,
  description: PropTypes.string,
  image: PropTypes.string.isRequired,
  top: PropTypes.number,
  children: PropTypes.node.isRequired,
};

export default CoverLayout;
